/*
* Pipeline Theme Custom Javascript
*/

(function() {

  // ============================================================
  // SOCK ADD-ON SELECTOR
  // ============================================================

  document.addEventListener('click', function(event) {

    var sockCard = event.target.closest('.sock-addon-card');

    if (sockCard) {
      event.preventDefault();

      var container = sockCard.closest('.product__sock-option');
      if (!container) return;

      var input = container.querySelector('.sock-addon-value');
      if (!input) return;

      // Reset all sock cards
      container.querySelectorAll('.sock-addon-card').forEach(function(card) {
        card.style.border = '1px solid #ddd';
        card.style.boxShadow = 'none';
      });

      // Highlight selected sock
      sockCard.style.border = '2px solid #000';

      // Store selected variant ID
      input.value = sockCard.dataset.addonId;

      return;
    }


    // No Socks
    var noSocks = event.target.closest('.sock-addon-none');

    if (noSocks) {
      event.preventDefault();

      var container = noSocks.closest('.product__sock-option');
      if (!container) return;

      var input = container.querySelector('.sock-addon-value');

      if (input) {
        input.value = '';
      }

      container.querySelectorAll('.sock-addon-card').forEach(function(card) {
        card.style.border = '1px solid #ddd';
        card.style.boxShadow = 'none';
      });

      return;
    }

  });



  // ============================================================
  // GRIP TAPE + BEARINGS IMAGE SELECTOR
  // ============================================================

  document.addEventListener('click', function(event) {

    var option = event.target.closest('.addon-details-option');

    if (!option) return;

    event.preventDefault();

    var container = option.closest('.product-addon-details');
    if (!container) return;

    var input = container.querySelector('.product-addon-select');
    var selected = container.querySelector('.addon-details-selected');
    var details = container.querySelector('.addon-details');

    if (!input || !selected) return;

    // Store selected variant ID
    input.value = option.dataset.addonId || '';

    var image = option.querySelector('img');

    // Selected actual product
    if (option.dataset.addonId && image) {

      selected.innerHTML =
        '<img src="' + image.src + '" ' +
        'style="width:35px;height:35px;object-fit:contain;flex-shrink:0;">' +
        '<span>' + option.dataset.addonTitle + '</span>';

    } else {

      // No Grip / No Bearings
      selected.textContent = option.dataset.addonTitle;

    }

    // Close dropdown after selection
    if (details) {
      details.removeAttribute('open');
    }

  });



  // ============================================================
  // ADD SELECTED ADD-ON TO CART
  // ============================================================

  document.addEventListener('click', async function(event) {

    var button = event.target.closest('[data-add-to-cart]');

    if (!button) return;

    var form = button.closest('form[data-product-form]');

    if (!form) return;

    var addonSelect = form.querySelector('.product-addon-select');

    // Nothing selected.
    // Let Pipeline handle Add to Cart normally.
    if (!addonSelect || !addonSelect.value) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var addonVariantId = parseInt(addonSelect.value, 10);

    var quantity = 1;

    var quantityInput = form.querySelector('[name="quantity"]');

    if (quantityInput) {
      quantity = parseInt(quantityInput.value, 10) || 1;
    }

    button.disabled = true;

    try {

      // Add the selected Grip, Bearings, or Socks first
      var response = await fetch('/cart/add.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: addonVariantId,
              quantity: quantity
            }
          ]
        })
      });


      var data = await response.json();


      if (!response.ok) {
        throw new Error(
          data.description ||
          'Unable to add selected item'
        );
      }


      // Clear add-on value so second click is handled normally
      addonSelect.value = '';

      button.disabled = false;


      // Pipeline now adds the main product normally
      // and opens the normal cart drawer.
      button.click();


    } catch (error) {

      console.error('Product add-on error:', error);

      alert(
        'There was a problem adding the selected add-on.'
      );

      button.disabled = false;

    }

  }, true);


})();